import React, { useState } from "react";
import ModalComponent from "../../../features/ModalComponent";
import { SubmitHandler, useForm } from "react-hook-form";
import { passValidator } from "../../../utils/formsValidation";
import FormInput from "../../../utils/FormInput";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { useDispatch } from "react-redux";
import { USER_CHANGE_PASS_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import { useTranslation } from "react-i18next";

type Inputs = {
  oldPassword: string;
  newPassword: string;
};

const ChangePassword: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const handleChangePassword: SubmitHandler<Inputs> = async (data) => {
    const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
    const { isError } = await post(USER_CHANGE_PASS_URL(facilityIds), {
      oldpassword: data.oldPassword,
      password: data.newPassword,
      token: parsedUserToken,
    });

    if (!isError) {
      dispatch(setSuccessMessage(t("operacja_przebiegla_pomyslnie")));
      setOpen(false);
    }
  };

  return (
    <React.Fragment>
      <button onClick={() => setOpen(true)} className="button medium padding-zero full-button button-text-gray">
        {t("zmiana_hasla")}
      </button>

      {open && (
        <ModalComponent
          footer={true}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("zmiana_hasla")}
          onAccept={handleSubmit(handleChangePassword)}
        >
          <form onSubmit={handleSubmit(handleChangePassword)}>
            <FormInput
              type={"password"}
              name={"oldPassword"}
              text={t("stare_haslo")}
              register={{ ...register("oldPassword", {}) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"password"}
              name={"newPassword"}
              text={t("nowe_haslo")}
              register={{ ...register("newPassword", { ...passValidator(true) }) }}
              errors={errors}
              isLabel
            />
          </form>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default ChangePassword;
